import { render, staticRenderFns } from "./CreateActionForm.vue?vue&type=template&id=82987bc4&"
import script from "./CreateActionForm.vue?vue&type=script&lang=ts&"
export * from "./CreateActionForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateActionForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports